<div class="main_body">
  <app-page-header
    [title]="i18n.title.userCreate"
    [subtitle]="i18n.subtitle.description"
    [backLabel]="backLabel"
    [backIcon]="backIcon"
    [useHistoryBack]="true"
    icon="user"
  />
  <div class="contents">
    <div class="contents_section_group">
      <section class="contents__section">
        <div class="form-container">
          <form [formGroup]="createUserFormGroup" (ngSubmit)="submit()">
            <!-- Registration Method Section -->
            <div class="form-section">
              <h4 class="form-section__title" i18n="@@adminSection.userCreate.section.registrationMethod">登録方法を選択</h4>
              <p class="form-hint" i18n="@@adminSection.userCreate.section.registrationMethodDesc">ユーザーの識別方法を選択してください</p>

              <div class="radio-cards-group">
                <div class="radio-card"
                     [class.radio-card--selected]="codeMode"
                     (click)="registrationMethodControl.setValue('code')"
                     (keydown.enter)="registrationMethodControl.setValue('code')"
                     (keydown.space)="registrationMethodControl.setValue('code')"
                     tabindex="0"
                     role="radio"
                     [attr.aria-checked]="codeMode">
                  <mat-icon class="radio-card__icon">badge</mat-icon>
                  <div class="radio-card__content">
                    <div class="radio-card__title" i18n="@@adminSection.userCreate.toggle.code">コードで登録</div>
                    <div class="radio-card__description" i18n="@@adminSection.userCreate.toggle.codeDesc">一意の識別コードでユーザーを管理</div>
                  </div>
                </div>

                <div class="radio-card"
                     [class.radio-card--selected]="!codeMode"
                     (click)="registrationMethodControl.setValue('name')"
                     (keydown.enter)="registrationMethodControl.setValue('name')"
                     (keydown.space)="registrationMethodControl.setValue('name')"
                     tabindex="0"
                     role="radio"
                     [attr.aria-checked]="!codeMode">
                  <mat-icon class="radio-card__icon">person</mat-icon>
                  <div class="radio-card__content">
                    <div class="radio-card__title" i18n="@@adminSection.userCreate.toggle.name">氏名で登録</div>
                    <div class="radio-card__description" i18n="@@adminSection.userCreate.toggle.nameDesc">姓と名でユーザーを識別</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Code Field (shown when code mode is selected) -->
            @if (codeMode) {
              <div class="form-section">
                <div class="form-label">
                  <span class="form-label__text" i18n="@@adminSection.userCreate.label.code">識別コード</span>
                  <span class="form-label__required">*</span>
                </div>
                <mat-form-field appearance="outline" class="form-field">
                  <input matInput formControlName="code" placeholder="例: USR-001" i18n-placeholder="@@adminSection.userCreate.placeholder.code" />
                  <mat-icon matSuffix class="material-icons-outlined">badge</mat-icon>
                  @if (codeFormControl.hasError('required') && codeFormControl.touched) {
                    <mat-error i18n="@@adminSection.userCreate.error.codeRequired">コードは必須です</mat-error>
                  }
                </mat-form-field>
                <p class="form-hint" i18n="@@adminSection.userCreate.hint.code">英数字とハイフンのみ使用可能</p>
              </div>
            }

            <!-- Name Fields (shown when name mode is selected) -->
            @if (!codeMode) {
              <div class="form-section">
                <div class="form-label">
                  <span class="form-label__text" i18n="@@adminSection.userCreate.label.name">氏名</span>
                  <span class="form-label__required">*</span>
                </div>
                <div class="form-row">
                  <mat-form-field appearance="outline" class="form-field form-field--half">
                    <mat-label i18n="@@adminSection.userCreate.label.lastName">姓</mat-label>
                    <input matInput formControlName="lastName" placeholder="山田" i18n-placeholder="@@adminSection.userCreate.placeholder.lastName" />
                    @if (lastNameFormControl.hasError('required') && (lastNameFormControl.touched || firstNameFormControl.touched)) {
                      <mat-error i18n="@@adminSection.userCreate.error.lastNameRequired">姓は必須です</mat-error>
                    }
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="form-field form-field--half">
                    <mat-label i18n="@@adminSection.userCreate.label.firstName">名</mat-label>
                    <input matInput formControlName="firstName" placeholder="太郎" i18n-placeholder="@@adminSection.userCreate.placeholder.firstName" />
                    @if (firstNameFormControl.hasError('required') && (lastNameFormControl.touched || firstNameFormControl.touched)) {
                      <mat-error i18n="@@adminSection.userCreate.error.firstNameRequired">名は必須です</mat-error>
                    }
                  </mat-form-field>
                </div>
              </div>
            }

            <div class="form-divider"></div>

            <!-- Optional Information Section -->
            <div class="form-section">
              <div class="form-label">
                <span class="form-label__text form-label__text--section" i18n="@@adminSection.userCreate.label.optionalInfo">オプション情報</span>
                <span class="badge badge--neutral" i18n="@@adminSection.userCreate.label.optional">任意</span>
              </div>

              <div class="form-fields-grid">
                <!-- Birth Date -->
                <div class="form-group">
                  <div class="form-label form-label--small">
                    <span class="form-label__text" i18n="@@adminSection.userCreate.label.birthDate">生年月日</span>
                  </div>
                  <mat-form-field appearance="outline" class="form-field">
                    <input matInput formControlName="birthDate" [matDatepicker]="birthDatePicker" placeholder="YYYY/MM/DD" />
                    <mat-datepicker-toggle matSuffix [for]="birthDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #birthDatePicker></mat-datepicker>
                  </mat-form-field>
                </div>

                <!-- Sex -->
                <div class="form-group">
                  <div class="form-label form-label--small">
                    <span class="form-label__text" i18n="@@adminSection.userCreate.label.sex">性別</span>
                  </div>
                  <mat-radio-group formControlName="sex" class="form-radio-group">
                    @for (option of sexOptions; track option.value) {
                      <mat-radio-button [value]="option.value" color="primary">
                        {{ option.display }}
                      </mat-radio-button>
                    }
                  </mat-radio-group>
                </div>
              </div>
            </div>

            <div class="form-divider"></div>

            <!-- Contract Start Date Section -->
            <div class="form-section">
              <div class="form-label">
                <span class="form-label__text" i18n="@@adminSection.userCreate.label.contractStartAt">利用開始日</span>
                <span class="form-label__required">*</span>
              </div>
              <mat-form-field appearance="outline" class="form-field form-field--date">
                <input matInput formControlName="contractStartAt" [matDatepicker]="contractDatePicker" placeholder="YYYY/MM/DD" />
                <mat-datepicker-toggle matSuffix [for]="contractDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #contractDatePicker></mat-datepicker>
                @if (contractStartAtFormControl.hasError('required')) {
                  <mat-error i18n="@@adminSection.userCreate.error.contractStartAtRequired">利用開始日は必須です</mat-error>
                }
              </mat-form-field>
            </div>

            <!-- Form Actions -->
            <div class="form-actions">
              <button mat-stroked-button
                      type="button"
                      (click)="resetFields()">
                <mat-icon>refresh</mat-icon>
                <span i18n="@@adminSection.userCreate.button.clearForm">クリア</span>
              </button>
              <button mat-flat-button
                      color="primary"
                      type="button"
                      #submitButton
                      [disabled]="!createUserFormGroup.valid || isSending()"
                      (click)="update()">
                @if (isSending()) {
                  <mat-spinner diameter="18"></mat-spinner>
                }
                <span i18n="@@adminSection.userCreate.button.create">ユーザーを作成</span>
              </button>
            </div>
          </form>
        </div>
      </section>
    </div>
  </div>
</div>
